import React, { useEffect } from 'react';
import './Location.css';
import './Home.css';
import DiscussForm from '../components/DiscussForm';

function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);

    return (
        <div className='location-main'>
            <div className='container-fluid'>
                <div className="container py-5">
                    <h1 className="text-center syne-title mb-4">
                        Privacy Policy<span className='text-rose'>.</span>
                    </h1>

                    <div className="row justify-content-center">
                        <div className="col-md-10 text-secondary">
                            <p>
                                <span className="text-rose">ZAMINDAAR INFRA</span> is a trusted real estate developer and landowner-centric property solution provider offering curated services to clients including investors, developers, individuals, and institutional buyers.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Our Commitment to Privacy</h4>
                            <p>
                                We believe that the responsible use of personal information collected on our websites is critical to our business objectives and reputation. The extent and type of information we receive from you on our external websites depends on the information you provide to us through our contact mailboxes and/or any registration processes.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Use of Information</h4>
                            <p>
                                We use your personally identifiable information to respond to your requests and provide you with information or marketing materials about <span className="text-rose">ZAMINDAAR INFRA</span>, unless you choose to opt out by writing to us at <span className="text-rose">contact@zamindaar.co.in</span>. We also use your information to maintain client relationships, inform you about properties and services of interest, and support other related business activities.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Collecting Information</h4>
                            <p>
                                Some websites may invite you to contact us or provide personal details. We use this to personalize your experience. We may use <span className="text-rose">cookies</span> to enhance usability. These cookies collect mostly statistical, non-personal data to help improve the site. We also use tools like <span className="text-rose">Google Analytics</span>. To opt out, visit <span className="text-rose">www.aboutcookies.org</span> or <span className="text-rose">allaboutcookies.org</span>.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Sharing Information</h4>
                            <p>
                                Your data is retained only as long as necessary. We do not share personal data except when needed to fulfill your request or required by law. We never sell your data. Information may be transferred to affiliated companies to support services. By submitting data electronically, you consent to trans-border transmission of your data.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Safeguarding Information</h4>
                            <p>
                                Only authorized personnel with proper training have access to your data. If you have questions or wish to unsubscribe from communications, contact us at <span className="text-rose">support@zamindaar.co.in</span>.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Linking to Other Sites</h4>
                            <p>
                                This policy applies to our official site <span className="text-rose">www.zamindaar.co.in</span>. Please review the privacy policies of any third-party websites you may access via links.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Location and Acceptance of Use</h4>
                            <p>
                                This site is operated from <span className="text-rose">Hyderabad, India</span>. All matters are governed under local laws. By using the site, you accept this Privacy Policy.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Data Retention and Erasure</h4>
                            <p>
                                You may request deletion of your data by emailing <span className="text-rose">support@zamindaar.co.in</span>. Please note that doing so may prevent us from providing services to you.
                            </p>

                            <h4 className='syne-title py-3 text-rose'>Disclaimer</h4>
                            <p>
                                <span className="text-rose">ZAMINDAAR INFRA</span> acts solely as a developer and facilitator of real estate transactions. All contractual obligations and transactions are directly between the buyer and respective project authorities. We are not liable for claims, delays, or deficiencies related to project execution. Always verify <span className="text-rose">RERA</span> registration and compliance independently before proceeding.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Optional: Discuss Form */}
            <DiscussForm />
        </div>
    );
}

export default PrivacyPolicy;
